var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 57.7469L18.662 69.583C23 66.7319 24.1945 64.4936 37.3831 65.4405C53.8688 66.6241 60.8542 63.9609 66.1632 54.4921C71.4722 45.0232 70.0751 44.1355 68.9574 43.5437C67.8397 42.9519 65.0455 43.5437 60.8542 50.9412C57.5012 56.8593 44.1823 56.7606 37.9419 55.9716V52.1248C40.6429 52.1248 47.3304 51.8881 52.4717 50.9412C58.8983 49.7576 56.9424 47.0945 54.4276 46.2068C51.9128 45.3191 37.9419 41.7682 29.8387 41.1764C23.3562 40.7029 13.9119 52.0261 10 57.7469Z",
    fill: "#00C5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2755 18.9647C51.2755 23.9158 47.4083 27.9294 42.6378 27.9294C37.8673 27.9294 34 23.9158 34 18.9647C34 14.0136 37.8673 10 42.6378 10C47.4083 10 51.2755 14.0136 51.2755 18.9647Z",
    fill: "#FFC508"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1455 18.9647C45.1455 23.9158 49.0128 27.9294 53.7833 27.9294C58.5538 27.9294 62.4211 23.9158 62.4211 18.9647C62.4211 14.0136 58.5538 10 53.7833 10C49.0128 10 45.1455 14.0136 45.1455 18.9647Z",
    fill: "#FFC508"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2105 21.5674V36.3158C40.1858 31.2261 34.8359 23.8809 34.5573 21.8566L48.2105 21.5674Z",
    fill: "#FFC508"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2105 21.5674V36.3158C56.2353 31.2261 61.5851 23.8809 61.8638 21.8566L48.2105 21.5674Z",
    fill: "#FFC508"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.1fca207959637f7a7dc3e287e5550bc7.svg";
export { ForwardRef as ReactComponent };